<template>
  <section
    class="banner"
    v-lazy:background-image="handleImg({ url: bg, width: 750, height: 406 })"
  >
    <div class="mask"></div>
    <div class="detail">
      <div class="intro">
        <img
          class="logo"
          v-lazy="handleImg({ url: logoD, width: 128, height: 128 })"
          :alt="name"
        />
        <div class="intro-text">
          <h1>{{ name }}</h1>
          <div class="area">
            <span>{{ `${countryName} I ${cityName}` }} </span>
          </div>
          <p>{{ slogan }}</p>
        </div>
      </div>
      <button
        class="btn-collect"
        :class="{ cancle: isUserLike }"
        @click="$emit('handle-collect')"
      >
        {{ collectText }}
      </button>
    </div>
    <div
      class="billboards"
      :style="{ visibility: noticeList ? 'visible' : 'hidden' }"
    >
    <van-swipe autoplay="5000" class="swipe" :show-indicators="false" vertical>
        <van-swipe-item class="swipe-item" v-for="(item, index) in noticeList" :key="index">
            {{ item }}
        </van-swipe-item>
    </van-swipe>
    </div>
  </section>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
export default {
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
    },
    props: {
        bg: String,
        logo: String,
        name: String,
        countryName: String,
        cityName: String,
        slogan: String,
        noticeList: Array,
        isUserLike: Number,
    },
    data() {
        return {
        }
    },
    computed: {
        logoD() {
            return (
                `${this.logo}` ||
        'https://fr-static.shopshops.top/20200328/dianpulogo.f2fb5760d3e67c86.png'
            );
        },
        collectText() {
            return this.isUserLike ? this.$t("message.store.cancelFollow") :  this.$t("message.store.follow");
        },
    },
};
</script>
<style lang="less" scoped>
img {
  display: block;
}
.banner {
  position: relative;
  width: 100%;
  height: 202.99px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-repeat: no-repeat;
  background-size: cover;
  // padding: 12px;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .detail {
    display: flex;
    width: 90%;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    z-index: 1;
    .btn-collect {
      height: 28px;
      padding: 0 16px;
      text-align: center;
      font-size: 14px;
      line-height: 28px;
      color: #fff;
      border-radius: 14px;
      background-color: #F66355;
    }
    .cancle {
      color: #161a1a;
      background-color: #f4f7f7;
    }
    .intro {
      display: flex;
      .logo {
        width: 64px;
        height: 64px;
        border-radius: 8px;
      }
      .intro-text {
        flex: 1;
        margin-left: 8px;
        color: #fff;
        text-align: left;
        max-width: 125px;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        word-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        h1 {
          font-size: 16px;
          line-height: 17.5px;      
        }
        .area {
          margin-top: 3.9px;
          font-size: 12px;
          line-height: 18px;
          font-family: "TradeGothicLT";
        }
        p {
          max-width: 200px;
          margin-top: 3.1px;
          font-size: 12px;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-wrap: break-word;
          word-break: break-word;
        }
      }
    }
  }
  .billboards {
    z-index: 1;
    width: 93%;
    height: 24px;
    padding: 0 12px;
    font-size: 11px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.35);
    overflow: hidden;
    .swipe{
        height: 24px;
    }
    .swipe-item{
        display: flex;
        align-items: center;
    }
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      white-space: normal;
    }
  }
}
</style>
